export const calculateTotalNf = (
  produtos: any[],
  xmlImportado: boolean,
): any => {
  return produtos.reduce((total, item) => {
    const valor = xmlImportado ? item.val_tot_nf : item.val_tabela_final;
    return total + (valor || 0);
  }, 0);
};
